import type { FC } from 'react';

import { formatCurrency, formatPhone } from 'utils/format.ts';

import Button from 'components/Button';
import HoverTooltip from 'components/HoverTooltip';
import Navigator from 'components/Navigator';
import Typography from 'components/Typography';

import { useSimulatorStore } from 'store/useSimulatorStore.ts';

import {
  IconText,
  InfoContainer,
  InfoQuote,
  MontosContainer,
  RowAmount,
  RowClientInfo,
  SubtitlesContainer,
  TextContainer,
  TitleContainer,
  ValueContainer,
  VerifyContainer,
  WrapperQuote,
} from './VerifyQuote.styled';

const VerifyQuote: FC = () => {
  const { form, reset } = useSimulatorStore();

  const handleReset = () => {
    reset();
  };

  return (
    <>
      <Navigator title="Cotizar préstamo" />
      <VerifyContainer>
        <TitleContainer>
          <Typography
            type="Title"
            size="small"
            style="semibold"
            color="#0C0C0C"
            children="Cotización #00005"
          />
        </TitleContainer>
        <WrapperQuote>
          <TextContainer>
            <IconText>
              <Typography style="bold" type="Label" color="#493F22">
                Monto del préstamo
              </Typography>
              <HoverTooltip
                title="Monto del préstamo."
                content="La presente cotización no constituye una oferta vinculante y no forma parte integral del contrato de préstamo y su respectiva carátula. La información del producto y políticas del préstamo contenidas en el cotizador están sujetas a cambios sin previo aviso."
                position="bottom"
              />
            </IconText>
            <Typography
              style="extralight"
              type="Caption"
              color="#666666"
              children="(Activos - enganche)"
            />
          </TextContainer>
          <Typography
            type="Headline"
            style="semibold"
            size="large"
            children={`$ ${formatCurrency(form?.valor_inmueble || '')}`}
            color="#0C0C0C"
          />
          <Typography
            type="Label"
            children={`Plazo ${form?.plazo}`}
            style="extralight"
            color="#7B6A3A"
          />
        </WrapperQuote>
        <MontosContainer>
          <SubtitlesContainer>
            <Typography
              type="Label"
              style="bold"
              size="large"
              children="Montos"
              color="#5F522D"
            />
          </SubtitlesContainer>
          <RowAmount>
            <span className="label">Enganche:</span>
            <span className="value">{`$ ${formatCurrency(form?.enganche || '')}`}</span>
          </RowAmount>
          <RowAmount>
            <span className="label">Pago mensual:</span>
            <span className="value">{`$ ${formatCurrency(form?.presupuesto_mensual || '')}`}</span>
          </RowAmount>
          <SubtitlesContainer>
            <Typography
              type="Label"
              style="bold"
              size="large"
              children="Activos"
              color="#5F522D"
            />
          </SubtitlesContainer>
          <ValueContainer>
            <RowAmount $divider={false}>
              <span className="label">Valor del inmueble:</span>
              <span className="value">{`$ ${formatCurrency(form?.valor_inmueble || '')}`}</span>
            </RowAmount>
            <RowAmount>
              <span className="label">Inversión 10% en BTC:</span>
              <span className="value">$1,000,000</span>
            </RowAmount>
            <RowAmount $divider={false}>
              <span className="label">Valor total de los activos:</span>
              <span className="value">$11,000,000</span>
            </RowAmount>
          </ValueContainer>
          <InfoQuote $divider={false}>
            <Typography children="Tasa de interés: " type="Label" />
            <Typography
              children="11%"
              type="Label"
              color="#BDAA75"
              style="bold"
            />
            <Typography children=" | CAT sin IVA: " type="Label" />
            <Typography
              children="10%"
              type="Label"
              color="#BDAA75"
              style="bold"
            />
          </InfoQuote>
        </MontosContainer>
        <InfoContainer>
          <RowClientInfo $divider={false}>
            <Typography
              children="Cliente:"
              type="Body"
              size="small"
              color="#5C5C5C"
            />
            <div>
              <Typography
                children={form?.nombre || ''}
                type="Body"
                size="medium"
              />
            </div>
          </RowClientInfo>
          <RowClientInfo $divider={false}>
            <Typography
              children="Número celular:"
              type="Body"
              size="small"
              color="#5C5C5C"
            />
            <div>
              <Typography
                children={formatPhone(form?.telefono || '')}
                type="Body"
                size="medium"
              />
            </div>
          </RowClientInfo>
          <RowClientInfo $divider={false}>
            <Typography
              children="Correo electrónico:"
              type="Body"
              size="small"
              color="#5C5C5C"
            />
            <div>
              <Typography
                children="gabriel.galardo@gmail.com"
                type="Body"
                size="medium"
              />
            </div>
          </RowClientInfo>
        </InfoContainer>
        <Button
          variant="outlined"
          children="Nueva cotización"
          onClick={handleReset}
        />
      </VerifyContainer>
    </>
  );
};

export default VerifyQuote;
